import { SchemaDeSer, SchemaDeSerBuilder } from "./deser"

export enum BROKER_OF_RECORD {
  TASTYTRADE_US = "tastytrade US",
  IG_UK = "IG UK",
  DEFAULT = "default",
}

export class PlatformConfiguration {
  autotrade = false
  apiAccess = false
  brokerOfRecord = BROKER_OF_RECORD.DEFAULT
  dividendReinvesting = false
  fullyPaidSecuritiesLending = false
  customerAccountAgreements = false
  displayFollowFeed = false
  displayTastyLive = false
  tradeCryptocurrencyEtf = false
  tradeCryptocurrencyEtfOption = false
  tradeCryptocurrencyFutures = false
  tradeCryptocurrencyUnderlying = false
  tradeEtf = false
  tradeEtfOption = false
  tradeFixedIncome = false
  tradeFx = false
}

/**
 * A few of the keys have been remapped to better align with the frontend naming
 */
export const PLATFORM_CONFIGURATION_DESER: SchemaDeSer<PlatformConfiguration> =
  new SchemaDeSerBuilder(PlatformConfiguration)
    .ofBoolean("autotrade", "allow-autotrade")
    .ofBoolean("dividendReinvesting", "allow-dividend-reinvesting")
    .ofBoolean(
      "fullyPaidSecuritiesLending",
      "allow-fully-paid-securities-lending"
    )
    .ofBoolean("apiAccess", "allow-open-api-access")
    .ofString("brokerOfRecord")
    .ofBoolean("customerAccountAgreements", "display-documents-and-agreements")
    .ofBoolean("displayFollowFeed")
    .ofBoolean("displayTastyLive")
    .ofBoolean("tradeCryptocurrencyEtf")
    .ofBoolean("tradeCryptocurrencyEtfOption")
    .ofBoolean("tradeCryptocurrencyFutures")
    .ofBoolean("tradeCryptocurrencyUnderlying")
    .ofBoolean("tradeEtf")
    .ofBoolean("tradeEtfOption")
    .ofBoolean("tradeFixedIncome")
    .ofBoolean("tradeFx")
    .toDeSer()
